export default "__VITE_ASSET__70d2e702__"